import React from 'react'
import { Link } from 'react-router-dom'
import SuperUserSettingsPageUI from '../../../templates/SuperUserSettingsPageUI'
import PageTitleUI from '../../../widgets/output/PageTitleUI'
import './EventsListPage.css'
import SpinnerComponentUI from '../../../components/common/SpinnerComponentUI'

const EventsListPageUI = ({ context, events, loading, error, onEditClick }) => {
  return (
    <SuperUserSettingsPageUI
      context={context}
      headerText="Events"
      page="events"
    >
      <div className="t_content_section">
        <div className="t_content_section_header">
          <PageTitleUI context={context} titleText="Events" />
        </div>
        <div className="t_content_section_body">
          
          {loading && <SpinnerComponentUI />}
          
          {error && (
            <div className="g_error g_m_top_50">
              {error}
            </div>
          )}
          
          {!loading && !error && events && events.length === 0 && (
            <div className="g_center g_m_top_100">
              <p className="g_muted">No events found. Create your first event!</p>
            </div>
          )}
          
          {!loading && !error && events && events.length > 0 && (
            <div className="events-table">
              <div className="events-table-head">
                <div className="events-row">
                  <div className="events-cell">Event Name</div>
                  <div className="events-cell">Category</div>
                  <div className="events-cell">Status</div>
                  <div className="events-cell">Admin Approval Required</div>
                  <div className="events-cell">Reminder Iteration</div>
                  <div className="events-cell">Created at</div>
                  <div className="events-cell">Updated at</div>
                  <div className="events-cell">Edit</div>
                </div>
              </div>
              <div className="events-table-body">
                {events.map(event => (
                  <div key={event.id} className="events-row">
                    <div className="events-cell">{event.name}</div>
                    <div className="events-cell">{event.category ? event.category : 'N/A'}</div>
                    <div className="events-cell">
                      <span className="status-tag active">{event.status}</span>
                    </div>
                    <div className="events-cell">{event.adminApprovalRequired ? 'Yes' : 'No'}</div>
                    <div className="events-cell">{event.reminderIteration}</div>
                    <div className="events-cell">{event.createdAt}</div>
                    <div className="events-cell">{event.updatedAt}</div>
                    <div className="events-cell">
                      <span className='icon icon-pencil g_link_2' onClick={() => onEditClick(event)} />
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
    </SuperUserSettingsPageUI>
  )
}

export default EventsListPageUI
